"use client";
import type { Prisma } from "@-/prisma";
import { createContext } from "react";
import type { CaseInclude } from "./include";

export type OrganizationLayoutContext = {
  caseData: Prisma.CaseGetPayload<{ include: CaseInclude }>;
};

const LayoutContext = createContext<OrganizationLayoutContext>(null!);

export default LayoutContext;
